import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';

interface Props {
  details?: { country_a?: string; country_b?: string } | null;
  onAcknowledge: () => Promise<void> | void;
}

export function MultiLocationWarningModal({ details, onAcknowledge }: Props) {
  const [agreed, setAgreed] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!agreed) return;
    setLoading(true);
    try { await onAcknowledge(); } finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 z-[9998] flex items-center justify-center bg-background/95 backdrop-blur-sm p-4">
      <div className="w-full max-w-lg rounded-2xl border border-primary/40 bg-card p-8 shadow-2xl">
        <div className="flex flex-col items-center text-center mb-6">
          <div className="w-20 h-20 rounded-full bg-primary/15 flex items-center justify-center mb-4">
            <AlertTriangle className="w-10 h-10 text-primary" />
          </div>
          <h2 className="text-2xl font-bold text-foreground mb-2">
            Acesso suspeito detectado
          </h2>
          <p className="text-muted-foreground">
            Detectamos que sua conta foi acessada de <strong>localidades muito distantes</strong> nas últimas 24 horas
            {details?.country_a && details?.country_b && details.country_a !== details.country_b ? (
              <> (<strong>{details.country_a}</strong> e <strong>{details.country_b}</strong>)</>
            ) : null}.
          </p>
        </div>

        <div className="rounded-lg border border-destructive/30 bg-destructive/10 p-4 mb-6 text-sm text-foreground">
          <p className="font-semibold mb-1">Aviso importante</p>
          <p className="text-muted-foreground">
            O Forja Hub é uma conta <strong>individual e intransferível</strong>. Compartilhar acesso viola nossos termos.
            Se este padrão continuar, sua conta poderá ser <strong>bloqueada permanentemente sem direito a reembolso</strong>.
          </p>
        </div>

        <label className="flex items-start gap-3 mb-6 cursor-pointer">
          <Checkbox checked={agreed} onCheckedChange={(v) => setAgreed(v === true)} className="mt-1" />
          <span className="text-sm text-muted-foreground">
            Reconheço este aviso e entendo que o uso da conta por outra pessoa pode causar o bloqueio sem reembolso.
          </span>
        </label>

        <Button
          onClick={handleConfirm}
          disabled={!agreed || loading}
          className="w-full"
        >
          {loading ? 'Confirmando…' : 'Entendi, continuar'}
        </Button>
      </div>
    </div>
  );
}